export default {
  setReferralsState(context, data) {
    context.allReferrals = data;
  },
  mutateReferralsLoadingState(context, loading) {
    context.loading = loading;
  },
  mutateReferralsErrorState(context, error) {
    context.error = error;
  },
  mutateReferralsDetailsErrorState(context, error) {
    context.referralDetailsError = error;
  },
  setReferralsMetaState(context, data) {
    context.meta = {...context.meta, ...data};
  },
  setReferralDetailsState(context, data) {
    context.referralDetailsBySlug = {
      ...context.referralDetailsBySlug,
      [data.slug]: data
    };
  },
  setReferrerState(context, data) {
    context.referrer = data;
  },
  mutateReferrerLoadingState(context, loading) {
    context.referrerLoading = loading;
  },
  addReferralInviteEmailState(context, email) {
    context.referralInvite.emails.push(email);
  },
  removeReferralInviteEmailState(context, email) {
    let index = context.referralInvite.emails.indexOf(email);

    context.referralInvite.emails.splice(index, 1);
  },
  clearReferralInviteEmailsState(context) {
    context.referralInvite.emails = [];
  },
  updateReferEmailsLoadingState(context, value) {
    context.referEmailsLoading = value;
  },
  updateReferAnonymouslyState(context, value) {
    context.referralInvite.is_anonymous = value;
  }
};
